import { Company } from '@schooly/api';

export type Payer<T> = (Company & { type: 'company' }) | (T & { type: 'guardian' });

export function getPayerId(payer: Payer<{ relation_id: string }>) {
  return payer.type === 'company' ? payer.id : payer.relation_id;
}
